import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function AdminClientes() {
  const navigate = useNavigate();
  const [clientes, setClientes] = useState([]);
  const [selected, setSelected] = useState(null);
  const [editSaldo, setEditSaldo]   = useState('');
  const [editTarifa, setEditTarifa] = useState('');
  const [editModel, setEditModel]   = useState('gpt-4o');
  const [recarga, setRecarga]       = useState('');
  const [saving, setSaving]         = useState(false);
  const [msg, setMsg]               = useState('');
  const [toggling, setToggling]     = useState(false);

  useEffect(() => {
    api.get('/admin/clientes').then(r => setClientes(r.data)).catch(() => {});
  }, []);

  const seleccionar = (c) => {
    setSelected(c);
    setEditSaldo(c.saldo || 0);
    setEditTarifa(c.tarifa_por_minuto || 290);
    setEditModel(c.llm_model || 'gpt-4o');
    setRecarga('');
    setMsg('');
  };

  const guardar = async () => {
    setSaving(true);
    try {
      await api.patch(`/admin/clientes/${selected.id}`, {
        saldo: parseFloat(editSaldo),
        tarifa_por_minuto: parseFloat(editTarifa),
        llm_model: editModel,
      });
      setClientes(prev => prev.map(c => c.id === selected.id ? { ...c, saldo: parseFloat(editSaldo), tarifa_por_minuto: parseFloat(editTarifa) } : c));
      setMsg('Guardado');
    } catch { setMsg('Error'); }
    setSaving(false);
  };

  const toggleStatus = async () => {
    setToggling(true);
    try {
      const nuevoStatus = selected.status === 'active' ? 'suspended' : 'active';
      await api.patch(`/admin/clientes/${selected.id}`, { status: nuevoStatus });
      setSelected(prev => ({ ...prev, status: nuevoStatus }));
      setClientes(prev => prev.map(c => c.id === selected.id ? { ...c, status: nuevoStatus } : c));
      setMsg(nuevoStatus === 'active' ? 'Cliente activado' : 'Cliente suspendido');
    } catch { setMsg('Error'); }
    setToggling(false);
  };

  const recargar = async () => {
    if (!recarga || isNaN(recarga)) return;
    setSaving(true);
    try {
      await api.post(`/admin/clientes/${selected.id}/recargar`, { monto: parseFloat(recarga) });
      const nuevoSaldo = parseFloat(editSaldo) + parseFloat(recarga);
      setEditSaldo(nuevoSaldo);
      setClientes(prev => prev.map(c => c.id === selected.id ? { ...c, saldo: nuevoSaldo } : c));
      setRecarga('');
      setMsg('Recarga aplicada');
    } catch { setMsg('Error en recarga'); }
    setSaving(false);
  };

  const inputStyle = {
    background: 'var(--bg)', border: '1px solid var(--surface-2)', borderRadius: 8,
    color: 'var(--text)', padding: '8px 12px', fontSize: 14, width: '100%', boxSizing: 'border-box'
  };
  const btnStyle = (color) => ({
    background: color, color: '#fff', border: 'none', borderRadius: 8,
    padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14
  });

  return (
    <div style={{ display: 'grid', gridTemplateColumns: selected ? '1fr 380px' : '1fr', gap: 24 }}>
      {/* Lista */}
      <div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', marginBottom: 20 }}>Clientes</h1>
        <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--surface)' }}>
                {['Empresa', 'Correo', 'Saldo COP', 'Tarifa/min', 'Plan'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '.06em' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {clientes.map(c => (
                <tr key={c.id}
                  onClick={() => seleccionar(c)}
                  style={{ borderBottom: '1px solid var(--surface)', cursor: 'pointer', background: selected?.id === c.id ? 'var(--surface)' : 'transparent' }}
                >
                  <td style={{ padding: '12px 16px', color: 'var(--text)', fontWeight: 600, cursor: 'pointer' }} onClick={() => navigate(`/admin/clientes/${c.id}`)}>{c.nombre_empresa} <span style={{color:'var(--accent-solid)',fontSize:11}}>→</span></td>
                  <td style={{ padding: '12px 16px', color: 'var(--text-2)', fontSize: 13 }}>{c.correo}</td>
                  <td style={{ padding: '12px 16px', color: 'var(--success)', fontWeight: 600 }}>${(c.saldo||0).toLocaleString('es-CO')}</td>
                  <td style={{ padding: '12px 16px', color: 'var(--text-2)' }}>${c.tarifa_por_minuto}/min</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{ background: 'var(--surface)', color: 'var(--accent)', padding: '2px 10px', borderRadius: 20, fontSize: 12 }}>{c.plan_activo || 'Basic'}</span>
                  </td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{
                      padding: '2px 10px', borderRadius: 20, fontSize: 12,
                      color: c.status === 'active' ? 'var(--success)' : 'var(--danger)',
                      background: c.status === 'active' ? 'var(--success-soft)' : 'var(--danger-soft)'
                    }}>{c.status === 'active' ? 'Activo' : 'Suspendido'}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Panel edición */}
      {selected && (
        <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
            <h2 style={{ color: 'var(--text)', fontSize: 16, fontWeight: 700, margin: 0 }}>{selected.nombre_empresa}</h2>
            <button onClick={() => setSelected(null)} style={{ background: 'none', border: 'none', color: 'var(--text-3)', cursor: 'pointer', fontSize: 18 }}>×</button>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ color: 'var(--text-3)', fontSize: 12, display: 'block', marginBottom: 6 }}>SALDO COP</label>
            <input style={inputStyle} type="number" value={editSaldo} onChange={e => setEditSaldo(e.target.value)} />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ color: 'var(--text-3)', fontSize: 12, display: 'block', marginBottom: 6 }}>TARIFA POR MINUTO</label>
            <input style={inputStyle} type="number" value={editTarifa} onChange={e => setEditTarifa(e.target.value)} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ color: 'var(--text-3)', fontSize: 12, display: 'block', marginBottom: 6 }}>MODELO DE IA</label>
            <select style={{ ...inputStyle, cursor: 'pointer' }} value={editModel} onChange={e => setEditModel(e.target.value)}>
              <option value="gpt-4o-mini">GPT-4o Mini (rápido y económico)</option>
              <option value="gemini-2.5-flash">Gemini 2.5 Flash ⭐ (más rápido, más barato)</option>
              <option value="gpt-4o">GPT-4o (más inteligente)</option>
              <option value="gpt-4.1">GPT-4.1</option>
              <option value="gpt-4.1-mini">GPT-4.1 Mini</option>
            </select>
          </div>

          <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
            <button onClick={guardar} disabled={saving} style={{ ...btnStyle('var(--accent-solid)'), flex: 1 }}>
              {saving ? 'Guardando...' : 'Guardar cambios'}
            </button>
            <button onClick={toggleStatus} disabled={toggling} style={{
              ...btnStyle(selected?.status === 'active' ? 'var(--danger)' : 'var(--success)'),
              flex: 1
            }}>
              {toggling ? '...' : selected?.status === 'active' ? '🔴 Suspender' : '🟢 Activar'}
            </button>
          </div>

          <div style={{ borderTop: '1px solid var(--surface)', paddingTop: 20, marginBottom: 16 }}>
            <label style={{ color: 'var(--text-3)', fontSize: 12, display: 'block', marginBottom: 6 }}>RECARGAR SALDO</label>
            <input style={{ ...inputStyle, marginBottom: 10 }} type="number" placeholder="Monto a recargar" value={recarga} onChange={e => setRecarga(e.target.value)} />
            <button onClick={recargar} disabled={saving} style={{ ...btnStyle('var(--success)'), width: '100%' }}>
              + Recargar
            </button>
          </div>

          {msg && <p style={{ color: msg.includes('✅') ? 'var(--success)' : 'var(--danger)', fontSize: 13, textAlign: 'center' }}>{msg}</p>}
        </div>
      )}
    </div>
  );
}
